import { IRets } from "@types";
import { BaseAPI } from "@utils";

class RetsApi extends BaseAPI<IRets> {}

export const retsApi = new RetsApi("/api/v1/maplisting/v2/rets");
